import classes from "./styles.module.css"
import {ReactComponent as IMAGE} from "./images/open_new_tab_img.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE, OPEN_ACTIVITY_IN_NEW_TAB,
    OPEN_ACTIVITY_IN_NEW_TAB_DESCRIPTION,
    POLL_TEXT,
    POLL_TYPE
} from "../../utils/constants";
import {deCapitalizeWord} from "../../utils/helpers";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import React, {useEffect, useState} from "react";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import Skeleton from "react-loading-skeleton";

export default function OpenNewTab({pollCode=""}) {
    const { getPollRecordFromUniqueCode,} = ResponseApiCalls();

    const [, getSession] = useLocalStorageNew("session", {});

    const [poll, setPoll] = useState({});
    const [dataReady, setDataReady] = useState(false)


    useEffect(() => {
        getPollRecordFromUniqueCode(pollCode).then(result => {
            setPoll(result.poll);
        }).finally(() => setDataReady(true));

    }, []);

    const onClickOpen = () => {
        const engageSession = encodeURIComponent(JSON.stringify(getSession()));
        const path = window.location.pathname;
        window.open(`/portal?engageSession=${engageSession}&dest=${path}&pollType=${poll.pollType}`);
    }

    if (!dataReady) {
        return (
            <div style={{width: "100%", height: "100%", padding: 15}}>
                <div className={classes.openNewTabCard}>
                    <div style={{flex: 1}}/>
                    <IMAGE/>
                    <div style={{height: 25, flexShrink: 1}}/>


                    <Skeleton width={400} height={25} inline={true} borderRadius={6} />

                    <div style={{height: 40, flexShrink: 1}}/>
                    <Skeleton width={200} height={25} inline={true} borderRadius={6} />
                    <div style={{flex: 1}}/>
                </div>
            </div>
        );
    }


    return (
        <div style={{width: "100%", height: "100%", padding: 15}}>
            <div className={classes.openNewTabCard}>
                <div style={{flex: 1}}/>
                <IMAGE/>
                <div style={{height: 25, flexShrink: 1}}/>


                <span>
                    {OPEN_ACTIVITY_IN_NEW_TAB_DESCRIPTION.replaceAll(
                        ACTIVITY_TYPE_PLACEHOLDER,
                        poll.pollType === POLL_TYPE.ATTENDANCE
                            ? deCapitalizeWord(ATTENDANCE)
                            : deCapitalizeWord(POLL_TEXT)
                    )}
                </span>
                <div style={{height: 40, flexShrink: 1}}/>
                <YuJaButton style={{height: 35}} onClick={onClickOpen}>
                    {OPEN_ACTIVITY_IN_NEW_TAB.replaceAll(
                        ACTIVITY_TYPE_PLACEHOLDER,
                        poll.pollType === POLL_TYPE.ATTENDANCE
                            ? ATTENDANCE
                            : POLL_TEXT
                    )}
                </YuJaButton>
                <div style={{flex: 1}}/>
            </div>
        </div>
    );
}